import { useCfarStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsCfarExerciseComponents } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";

import { AirCfarExerciseGenericActionView } from "../AirCfarExerciseGenericActionView";

import defaultStyles from "./AirCfarExerciseErrorExercised.module.scss";

export interface AirCfarExerciseErrorExercisedProps {
  onContactSupportClick: () => void;
  onGoBackClick: () => void;
}

export const AirCfarExerciseErrorExercised = (
  props: AirCfarExerciseErrorExercisedProps
) => {
  const [block, cn] = useModuleBEM(
    useCfarStyles(
      CoreFlightsCfarExerciseComponents.AirCfarExerciseErrorExercised,
      defaultStyles
    ),
    CoreFlightsCfarExerciseComponents.AirCfarExerciseErrorExercised
  );
  const { t } = useI18nContext();

  const { onContactSupportClick, onGoBackClick } = props;

  return (
    <div className={block}>
      <AirCfarExerciseGenericActionView
        title={t("core-flights-cfar.exercise.errorExercised.title")}
        description={t("core-flights-cfar.exercise.errorExercised.description")}
        footerButtons={[
          <button
            className={cn("contact-support-button")}
            onClick={onContactSupportClick}
          >
            {t("core-flights-cfar.exercise.errorExercised.contactSupport")}
          </button>,
          <button className={cn("go-back-button")} onClick={onGoBackClick}>
            {t("core-flights-cfar.exercise.errorExercised.goBack")}
          </button>,
        ]}
      />
    </div>
  );
};
